import { createRoute } from "@tanstack/react-router";
import { requireManager } from "@/lib/authGuards";
import SubscriptionManagementContainer from "@/features/manager/pages/SubscriptionManagementContainer";
import AddNewUserContainer from "@/features/manager/pages/AddNewUserContainer";
import EditUserContainer from "@/features/manager/pages/EditUserContainer";
import AddNewTokenContainer from "@/features/manager/pages/AddNewTokenContainer";
import TeamManagementContainer from "@/features/manager/pages/TeamManagementContainer";
import type { AnyRoute } from "@tanstack/react-router";

export function createManagerRoutes(rootRoute: AnyRoute) {
  const managerParent = createRoute({
    getParentRoute: () => rootRoute,
    path: "/manager",
    beforeLoad: requireManager,
    staticData: { layout: "app" },
  });

  const managerSubscriptionManagementRoute = createRoute({
    getParentRoute: () => managerParent,
    path: "subscription-management",
    component: SubscriptionManagementContainer,
  });

  const managerSubscriptionOverviewRoute = createRoute({
    getParentRoute: () => managerParent,
    path: "subscription-management/overview",
    component: SubscriptionManagementContainer,
  });

  const managerSubscriptionUsageRoute = createRoute({
    getParentRoute: () => managerParent,
    path: "subscription-management/usage",
    component: SubscriptionManagementContainer,
  });

  const managerSubscriptionActivityRoute = createRoute({
    getParentRoute: () => managerParent,
    path: "subscription-management/activity",
    component: SubscriptionManagementContainer,
  });

  const managerAddNewUserRoute = createRoute({
    getParentRoute: () => managerParent,
    path: "subscription-management/add-new-user",
    component: AddNewUserContainer,
  });

  const managerEditUserRoute = createRoute({
    getParentRoute: () => managerParent,
    path: "subscription-management/edit-user/$hashKeyId",
    component: EditUserContainer,
    validateSearch: (search: Record<string, unknown>) => ({
      hashKeyId: search.hashKeyId ? String(search.hashKeyId) : undefined,
    }),
  });

  const managerAddNewTokenRoute = createRoute({
    getParentRoute: () => managerParent,
    path: "subscription-management/add-new-token",
    component: AddNewTokenContainer,
  });

  const managerTeamManagementRoute = createRoute({
    getParentRoute: () => managerParent,
    path: "team-management",
    component: TeamManagementContainer,
  });

  return managerParent.addChildren([
    managerSubscriptionManagementRoute,
    managerSubscriptionOverviewRoute,
    managerSubscriptionUsageRoute,
    managerSubscriptionActivityRoute,
    managerAddNewUserRoute,
    managerEditUserRoute,
    managerAddNewTokenRoute,
    managerTeamManagementRoute,
  ]);
}
